import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('extractJson');
const type = createActionType('extractJson');

export const INITIALIZE = type('Initialize');
export const SELECT_COLUMN = type('SelectColumn');
export const LOAD_METRICS = apiType('LoadMetrics');
export const CLOSE_EDITOR = type('CloseEditor');
export const SAVE_EXTRACT_JSON = type('SaveExtractJson');
export const CREATE_EXTRACT_JSON = apiType('CreateExtractJson');
export const UPDATE_EXTRACT_JSON = apiType('UpdateExtractJson');
export const SELECT_JSON_NODE = type('SelectJsonNode');
export const TOGGLE_EXTRACT_JSON = type('ToggleExtractJson');
export const UPDATE_TYPE = type('UpdateType');
export const INITIALIZE_STATE = type('InitializeState');
export const INITIALIZE_CLOSE_EDITOR = type('InitializeCloseEditor');
export const CLEAR_EXTRACTED_COLUMNS = type('ClearExtractedColumns');
export const CALC_METRICS_FROM_PREVIEW = type('CalcPathsFromPreview');
export const START_FULL_METRICS_CALC = type('StartFullMetricsCalc');
export const RELOAD_PREVIEW = type('ReloadPreview');
export const LOAD_PREVIEW = type('LoadPreview');
export const TOGGLE_EXPAND_ARRAY = type('ToggleExpandArray');
